import BaseReportController from '../../baseReportController';
import { filter as _filter } from 'lodash';
import { find as _find } from 'lodash';

class ReportsUsageController extends BaseReportController {
  constructor(authService, reportingService, loadingService, utilsService, entityService, enums, reportsUsageService, $scope) {
    "ngInject";

    super(reportingService, loadingService, utilsService);

    if(!authService.validateUser(true, 'Reports', enums.PERMISSION_TYPE.View, true)) { return; }

    this.authService = authService;
    this.reportingService = reportingService;
    this.loadingService = loadingService;
    this.utilsService = utilsService;
    this.entityService = entityService;
    this.enums = enums;
    this.reportsUsageService = reportsUsageService;
    this.$scope = $scope;

    this.reportCriteria = {
      locationIds: []
    };
    this.dtPopups = {};
    this.errMsgs = [];
    
    this.panels = {
      reportCriteria: true,
      reportData: false
    };

    this.locationSelectSettings = {
      displayProp: 'name', 
      idProp: 'entityId',
      enableSearch: true,
      scrollableHeight: '500px',
      scrollable: true,
      styleActive: true,
      closeOnBlur: true,
    }

    this.breakdownByBrands = null;
    this.breakdownByLocations = null;
    this.breakdownByType = null;
    this.breakdownByOutputType = null;
    this.breakdownBySalesPerson = null;

    this.selectedBrand = null;
    this.selectedLocation = null;
    this.selectedType = null;
    this.selectedOutputType = null;

    this.$scope.$on('leadMonitor:selectionChanged', this.selectionChanged.bind(this));

    this.getLocations();
    this.getDateRangeList();
    this.reset()
      .then(response => {
        //this.viewAnalytics();    
      });    
  }

  getLocations(){
    this.entityService.listAllLocations()
      .then(response => {
        this.locations = response.data.items;
      });
  }

  convertEnumToKeyValueList(enumObj, defaultOption) {
    let objList = [];

    if (defaultOption) {
      objList.push({
        id: null,
        name: 'Please Select'
      })
    }

    for(let prop in enumObj){
      objList.push({
        id: enumObj[prop],
        name: prop
      });
    }

    return objList;
  }

  getDateRangeList() {
    this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
  }

  getUserLocations() {
    this.userLocations = this.authService.authData.userLocations.map(l => {
      return {id: l.key, name: l.value};
    });

    this.userLocations.unshift({id: null, name: 'All'})
  }

  showDatePopup(fieldName) {
    this.dtPopups[fieldName] = true;
  }

  reset() {    
    this.errMsgs = [];

    this.reportCriteria.dateRangeOption = this.dateRangeList[0];
    this.reportCriteria.startDate = new Date();
    this.reportCriteria.endDate = new Date();
    this.reportCriteria.locationIds = [];

    this.resetSelection();

    return this.updateDateRange();
  }

  resetSelection() {
    this.breakdownByBrands = null;
    this.breakdownByLocations = null;
    this.breakdownByType = null;
    this.breakdownByOutputType = null;
    this.breakdownBySalesPerson = null;


    this.selectedBrand = null;
    this.selectedLocation = null;
    this.selectedType = null;
    this.selectedOutputType = null;
  }

  viewAnalytics() {
    this.panels.reportData = true;

    if (!this.validateCriteria()) {
      return;
    }

    this.breakdownByBrands = null;
    this.breakdownByLocations = null;
    this.breakdownByType = null;
    this.breakdownByOutputType = null;
    this.breakdownBySalesPerson = null;

    const parsedCriteria = this.parseCriteria();

    this.reportsUsageService.getReportsBreakdownByBrand(parsedCriteria)
      .then(response => { this.breakdownByBrands = response.data; });

    this.reportsUsageService.getReportsBreakdownByLocation(parsedCriteria)
      .then(response => { this.breakdownByLocations = response.data; });

    this.reportsUsageService.getReportsBreakdownByType(parsedCriteria)
      .then(response => { this.breakdownByType = response.data; });

    this.reportsUsageService.getReportsBreakdownByOutputType(parsedCriteria)
      .then(response => { this.breakdownByOutputType = response.data; });

    this.reportsUsageService.getReportsBreakdownBySalesPerson(parsedCriteria)
      .then(response => { this.breakdownBySalesPerson = response.data; });
      
  }

  validateCriteria() {
    this.errMsgs = [];

    if (!this.reportCriteria.startDate) {
      this.errMsgs.push('Please provide a Start Date');
    }

    if (!this.reportCriteria.endDate) {
      this.errMsgs.push('Please provide an End Date');
    }

    if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
      this.errMsgs.push('Start Date can not be greater than End Date');
    }

    return this.errMsgs.length === 0;
  }

  parseCriteria() {
    let parsedCriteria = {};

    this.parseStartAndEndDate(parsedCriteria);
    
    parsedCriteria.locationIds = this.reportCriteria.locationIds.map(l => l.entityId);
    parsedCriteria.additionalParameter1 = this.selectedBrand;
    parsedCriteria.additionalParameter2 = this.selectedLocation;
    parsedCriteria.additionalParameter3 = this.selectedType;
    parsedCriteria.additionalParameter4 = this.selectedOutputType;

    return parsedCriteria;
  }

  selectionChanged(e, data) {
    if (data.event === 'brandSelected') { 
      this.selectedBrand = this.addUpdateParameter(this.selectedBrand, data.identifiers.name);
      this.selectedLocation = null;
      this.selectedType = null;
      this.selectedOutputType = null;

      this.updateLocations();
    }
    else if (data.event === 'locationSelected') {
      this.selectedLocation = this.addUpdateParameter(this.selectedLocation, data.identifiers.identifier);;
      this.selectedType = null;
      this.selectedOutputType = null;

      this.updateType();
    }    

    else if (data.event === 'typeSelected') {
      this.selectedType = this.addUpdateParameter(this.sselectedType, data.identifiers.identifier);;
      this.selectedOutputType = null;

      this.updateOutputType();
    }  

    else if (data.event === 'outputTypeSelected') {
      this.selectedOutputType = this.addUpdateParameter(this.selectedOutputType, data.identifiers.identifier);;

      this.updateOutputType();
    }      
  }

  updateLocations() {
    this.breakdownByLocations = null;

    this.reportsUsageService.getReportsBreakdownByLocation(this.parseCriteria())
      .then(response => { this.breakdownByLocations = response.data; });
    
    this.updateType();
  }  

  updateType() {
    this.breakdownByType = null;

    this.reportsUsageService.getReportsBreakdownByType(this.parseCriteria())
    .then(response => { this.breakdownByType = response.data; });
    
    this.updateOutputType();
  }  

  updateOutputType() {
    this.breakdownByOutputType = null;

    this.reportsUsageService.getReportsBreakdownByOutputType(this.parseCriteria())
    .then(response => { this.breakdownByOutputType = response.data; });
    
    this.updateSalesPerson();
  }    

  updateSalesPerson() {
    this.breakdownBySalesPerson = null;

    this.reportsUsageService.getReportsBreakdownBySalesPerson(this.parseCriteria())
    .then(response => { this.breakdownBySalesPerson = response.data; });
  }    

  addUpdateParameter(currentValue, newValue){
    if (currentValue === newValue) {
      return null;
    }
    
    return newValue;
  }

  titleBuilder(base, params) {
    let title = base;

    params.map(p => {
      if (p.name) {
        title += ` ${p.category} ${p.name},`;  
      }      
    });

    return base;
  }

  forWebEnquiry() {
    return this.reportCriteria.dataSource.id === 1;
  }

  getLabel(item) {
    return item.name;
  }

  getCount(item) {
    return item.count;
  }  
}

export default ReportsUsageController;


// WEBPACK FOOTER //
// ./client/app/components/reports/adminReports/reportsUsage/reportsUsage.controller.js